import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Extrae el número más bajo de un string de precio ("$600 – $900 MXN" -> 600)
export function parsePriceMXN(priceStr) {
  if (!priceStr) return 0;
  const match = String(priceStr).replace(/,/g, '').match(/\d+(\.\d+)?/);
  return match ? parseFloat(match[0]) : 0;
}

export function formatMXN(amount) {
  return new Intl.NumberFormat('es-MX').format(amount);
}

// Debe coincidir con SHIPPING_COST_MXN / FREE_SHIPPING_THRESHOLD_MXN en backend/server.py.
export const SHIPPING_COST_MXN = 150;
export const FREE_SHIPPING_THRESHOLD_MXN = 1500;

export function getShippingCost(subtotal) {
  return subtotal >= FREE_SHIPPING_THRESHOLD_MXN ? 0 : SHIPPING_COST_MXN;
}
